export interface AgentTabSpec {
  key: string;
  label: string;
  custom?: boolean;
}

export const AGENTS_BASE_PATH = '/agents';
export const AGENT_DETAIL_ROUTE_PATH = '/agents/:agentKey/*';
export const AGENT_TAB_PATH_TEMPLATE = '/agents/:agentKey/:tabKey';
export const LEGACY_AGENT_DASHBOARD_PATH = '/financial-clearance/agent-dashboard';

export const DEFAULT_AGENT_TAB = 'overview';
export const EVA_WORKLIST_TAB = 'worklist';

export const BASE_AGENT_TABS: AgentTabSpec[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'steps', label: 'Steps' },
  { key: 'configuration', label: 'Configuration' },
];
